export default __webpack_public_path__ + "static/media/area-34.87ccf3e5.jpg";